export default __webpack_public_path__ + "static/media/Celebrations.136e58ef.png";